/* eslint-disable no-unused-vars */
import React from "react";
import "./styles.scss";
import HeroSection from "./HeroSection.jsx";
import ProjectSynopsis from "./ProjectSynopsis.jsx";
import GalleryBanner from "./GalleryBanner.jsx";
import Amenities from "./Amenities.jsx";
import Location from "./Location.jsx";
import ProjectSpecification from "./ProjectSpecifications.jsx";
import FloorPlan from "./FloorPlans.jsx";
import ModelApartment from "./ModelApartment.jsx";
import Gallery from "./Gallery.jsx";
import ProjectStatus from "./ProjectStatus.jsx";
import { Helmet } from "react-helmet";
import Layout from "../../common/Layout.js";

function Main({ seoData }) {
  return (
    <Layout seoData={seoData}>
    <Helmet>
      <script type="text/javascript">
        {`
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "t1w7fqd25m");
        `}
      </script>
      {/* Google tag (gtag.js) */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-XC035Q2RTE"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-XC035Q2RTE');
        `}
      </script>
    </Helmet>
      <HeroSection />
      <ProjectSynopsis />
      <GalleryBanner />
      <Amenities />
      <Location />
      <ProjectSpecification />
      <FloorPlan />
      <ModelApartment />
      <Gallery />
      <ProjectStatus />
    </Layout>
  );
}

export default Main;
